export const ADD_BOOK_INFO = "booking/Add_book_info";
export const REMOVE_BOOK_INFO = "booking/Remove_book_info";
